import { ObjectValueType } from "../types/utilityTypes/ObjectValueType";

/**
 * Вид цены предложения. Соответствует словарю rate_mode
 * @prop ONE_TIME: 1, // Разовая
 * @prop  PERIODIC: 2, // Периодическая
 * @prop TRAFFIC: 3, // Трафик(объемная)
 */

export const RateModes = {
  ONE_TIME: 1, // Разовая
  PERIODIC: 2, // Периодическая
  TRAFFIC: 3, // Трафик(объемная)
} as const;

export type RateModes = ObjectValueType<typeof RateModes>;
